<script lang="ts">
  import type { DrawingStyle } from '@annotorious/core';
  import { createEventDispatcher, onMount, type SvelteComponent } from 'svelte';
  import type { ImageAnnotation, Shape } from '../../model';
  import { computeStyle } from '../utils/styling';
  import type { Transform } from '../Transform';

  const dispatch = createEventDispatcher<{ change: Shape }>();

  /** Props */
  export let annotation: ImageAnnotation;
  export let editor: typeof SvelteComponent;
  export let style: DrawingStyle | ((annotation: ImageAnnotation) => DrawingStyle) = undefined;
  export let target: SVGGElement;
  export let transform: Transform;
  export let viewportScale: number;

  let editorComponent: SvelteComponent;

  $: computedStyle = computeStyle(annotation, style);

  $: if (editorComponent) editorComponent.$set({ transform });

  $: if (editorComponent) editorComponent.$set({ viewportScale });

  onMount(() => {
    editorComponent = new editor({
      target,
      props: { shape: annotation.target.selector, computedStyle, transform, viewportScale }
    });

    editorComponent.$on('change', event => {
      editorComponent.$$set({ shape: event.detail });
      dispatch('change', event.detail)
    });

    return () => {
      editorComponent.$destroy();
    }
  });
</script>